import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    ArrowDown,
    ArrowLeft,
    Building2,
    Calculator,
    Check,
    ChevronLeft,
    ChevronRight,
    Cloud,
    Coins,
    Download,
    FileText,
    Globe,
    Mail,
    MapPin,
    PackageCheck,
    Phone,
    Search,
    ShieldCheck,
    Users,
    Wallet,
    X,
    ZoomIn,
    ZoomOut,
} from "lucide-react";
import { Reveal, MaskedLine, Counter } from "../components/motion/Reveal";

const A = "/assets/sadjagroup";
const GLOBE_LOGO = "/assets/logo-sadja-group-transparent.png";

const NAVY = {
    base: "#0a1628",
    panel: "#0f1f38",
    line: "#1e3a5f",
    blue: "#38bdf8",
    green: "#4ade80",
};

const MENU = [
    { id: "sgi-profil", label: "Profil" },
    { id: "sgi-spesialisasi", label: "Spesialisasi" },
    { id: "sgi-rekam-jejak", label: "Rekam Jejak" },
    { id: "sgi-produk", label: "Produk" },
    { id: "sgi-mitra", label: "Mitra" },
    { id: "sgi-tim", label: "Tim" },
    { id: "sgi-legalitas", label: "Legalitas" },
    { id: "sgi-sertifikat", label: "Sertifikat" },
    { id: "sgi-kbli", label: "KBLI" },
    { id: "sgi-kontak", label: "Kontak" },
];

const KBLI_PROSES = [
    [1, "46499", "Perdagangan Besar Berbagai Barang dan Perlengkapan Rumah Tangga Lainnya YTDL"],
    [2, "46411", "Perdagangan Besar Tekstil"],
    [3, "47711", "Perdagangan Eceran Pakaian"],
    [4, "47611", "Perdagangan Eceran Alat Tulis Menulis dan Gambar"],
    [5, "47599", "Perdagangan Eceran Peralatan dan Perlengkapan Rumah Tangga Lainnya dalam Subgolongan 4759"],
    [6, "47411", "Perdagangan Eceran Komputer dan Perlengkapannya"],
    [7, "46523", "Perdagangan Besar Peralatan Telekomunikasi"],
    [8, "26391", "Industri Kartu Cerdas (Smart Card)"],
    [9, "58200", "Penerbitan Piranti Lunak (Software)"],
    [10, "63990", "Aktivitas Jasa Informasi Lainnya YTDL"],
    [11, "77313", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Transportasi Udara"],
    [12, "77321", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Perekaman Gambar & Editing"],
    [13, "77319", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Transportasi Lainnya"],
    [14, "77393", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin dan Peralatan Konstruksi dan Teknik Sipil"],
    [15, "62090", "Aktivitas Teknologi Informasi dan Jasa Komputer Lainnya"],
    [16, "63111", "Aktivitas Pengolahan Data"],
    [17, "77311", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Transportasi Darat Bukan Kendaraan Bermotor Roda Empat atau Lebih"],
    [18, "77312", "Aktivitas Sewa Guna Usaha Tanpa Hak Opsi Alat Transportasi Air"],
    [19, "77323", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Kebutuhan MICE"],
    [20, "77329", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin dan Peralatan Industri Kreatif Lainnya"],
    [21, "77392", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin Pertanian dan Peralatannya"],
    [22, "77394", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin Kantor dan Peralatannya"],
    [23, "77395", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin Pertambangan dan Energi serta Peralatannya"],
    [24, "77399", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin, Peralatan dan Barang Berwujud Lainnya YTDL"],
    [25, "62019", "Aktivitas Pemrograman Komputer Lainnya"],
    [26, "63122", "Portal Web dan/atau Platform Digital dengan Tujuan Komersial"],
    [27, "26210", "Industri Komputer dan/atau Perakitan Komputer"],
    [28, "77322", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Alat Bantu Teknologi Digital"],
    [29, "62024", "Aktivitas Konsultasi dan Perancangan Internet of Things (IoT)"],
    [30, "18113", "Industri Pencetakan 3D Printing"],
    [31, "62015", "Aktivitas Pemrograman Berbasis Kecerdasan Artifisial"],
    [32, "62014", "Aktivitas Pengembangan Teknologi Blockchain"],
    [33, "52219", "Aktivitas Penunjang Angkutan Darat Lainnya"],
    [34, "70209", "Aktivitas Konsultasi Manajemen Lainnya"],
    [35, "52214", "Aktivitas Perparkiran di Badan Jalan (On Street Parking)"],
    [36, "52211", "Aktivitas Terminal Darat"],
    [37, "52215", "Aktivitas Perparkiran di Luar Badan Jalan (Off Street Parking)"],
    [38, "62021", "Aktivitas Konsultasi Keamanan Informasi"],
    [39, "62022", "Aktivitas Penyediaan Identitas Digital"],
    [40, "62023", "Aktivitas Penyediaan Sertifikat Elektronik dan Layanan yang Menggunakan Sertifikat Elektronik"],
    [41, "62029", "Aktivitas Konsultasi Komputer dan Manajemen Fasilitas Komputer Lainnya"],
    [42, "63112", "Aktivitas Hosting dan YBDI"],
    [43, "77391", "Aktivitas Penyewaan dan Sewa Guna Usaha Tanpa Hak Opsi Mesin dan Peralatan"],
    [44, "17013", "Industri Kertas Berharga"],
    [45, "66411", "Penyedia Jasa Pembayaran (PJP)"],
    [46, "66412", "Penyelenggara Infrastruktur Sistem Pembayaran (PIP)"],
    [47, "18112", "Industri Pencetakan Khusus"],
    [48, "66413", "Penyelenggara Penunjang Sistem Pembayaran"],
    [49, "61922", "Jasa Sistem Komunikasi Data"],
    [50, "61923", "Jasa Televisi Protokol Internet (IPTV)"],
    [51, "61924", "Jasa Interkoneksi Internet (NAP)"],
    [52, "61929", "Jasa Multimedia Lainnya"],
    [53, "61921", "Internet Service Provider"],
    [54, "74909", "Aktivitas Profesional, Ilmiah dan Teknis Lainnya YTDL"],
];

const USULAN_KBLI = [
    {
        no: 1,
        kbli: "62091",
        nama: "Aktivitas Operasi Sistem Komputer Terintegrasi",
        peran: "KBLI Utama",
        justifikasi: "operator & pengelola sistem ITS, AFC, FMS, PIS, ENJI, AI dalam skema managed service dengan SLA dan operasi berkelanjutan.",
    },
    {
        no: 2,
        kbli: "71102",
        nama: "Aktivitas Keinsinyuran dan Konsultasi Teknis YBDI",
        peran: "KBLI Utama",
        justifikasi: "menguatkan posisi sebagai system integrator ITS, perancang arsitektur sistem transportasi cerdas, dan mitra teknis proyek strategis nasional Ditjen Integrasi Transportasi Multimoda.",
    },
    {
        no: 3,
        kbli: "52219",
        nama: "Aktivitas Penunjang Angkutan Darat Lainnya",
        peran: "Transport - Darat",
        justifikasi: "mendukung layanan ITS untuk transportasi publik darat, termasuk BTS, BOK, Dishub, BUMD, serta pengawasan dan manajemen operasional armada.",
    },
    {
        no: 4,
        kbli: "52229",
        nama: "Aktivitas Penunjang Angkutan Air Lainnya",
        peran: "Transport - Laut",
        justifikasi: "mendukung dan mengintegrasikan sistem ITS pada moda transportasi air (pelabuhan, ferry) dalam skema antar moda darat-laut.",
    },
    {
        no: 5,
        kbli: "52239",
        nama: "Aktivitas Penunjang Angkutan Udara Lainnya",
        peran: "Transport - Udara",
        justifikasi: "mendukung integrasi sistem ITS pada lingkungan bandara, termasuk shuttle, feeder, dan konektivitas darat-udara.",
    },
    {
        no: 6,
        kbli: "52291",
        nama: "Jasa Pengurusan Transportasi",
        peran: "Multimoda / Antarmoda",
        justifikasi: "berfungsi sebagai payung hukum kegiatan integrasi perjalanan lintas moda, sistem informasi perjalanan, dan ekosistem mobilitas terintegrasi.",
    },
    {
        no: 7,
        kbli: "62030",
        nama: "Aktivitas Pengelolaan Infrastruktur Teknologi Informasi",
        peran: "Pendukung Operasional",
        justifikasi: "mendukung pengelolaan infrastruktur TI seperti NOC, SOC, cloud, monitoring sistem, dan layanan operasional 24/7.",
    },
    {
        no: 8,
        kbli: "46512",
        nama: "Perdagangan Besar Piranti Lunak",
        peran: "Komersial / Pendukung",
        justifikasi: "digunakan untuk aspek komersial seperti penjualan lisensi software, distribusi aplikasi, dan e-catalog, bersifat mendukung dan melengkapi kegiatan utama perusahaan.",
    },
];

const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -132, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

const SectHead = ({ overline, title, accent = "blue", center = false }) => (
    <Reveal>
        <div className={`mb-12 ${center ? "text-center" : ""}`}>
            <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
                <span className="h-px w-10" style={{ background: accent === "green" ? NAVY.green : NAVY.blue }} aria-hidden="true" />
                <span
                    className="font-display text-[11px] font-semibold tracking-[0.32em] uppercase"
                    style={{ color: accent === "green" ? NAVY.green : NAVY.blue }}
                >
                    {overline}
                </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-4">
                {title}
            </h2>
        </div>
    </Reveal>
);

export default function SadjaGroupPage() {
    const [lightbox, setLightbox] = useState(null);
    const [kbliQuery, setKbliQuery] = useState("");

    useEffect(() => {
        document.title = "PT Sadja Group Indonesia | Sadja Core Corp";
        const meta = document.querySelector('meta[name="description"]');
        const prev = meta?.getAttribute("content");
        meta?.setAttribute(
            "content",
            "Profil PT Sadja Group Indonesia — teknologi informasi & infrastruktur: pengembangan perangkat lunak, cyber security, hardware, sistem pembayaran, solusi transportasi publik, dan konstruksi."
        );
        window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
        return () => {
            document.title = "Sadja Core Corp — Building the Future of Energy & Infrastructure";
            if (meta && prev) meta.setAttribute("content", prev);
        };
    }, []);

    useEffect(() => {
        const onKey = (e) => {
            if (!lightbox) return;
            if (e.key === "Escape") setLightbox(null);
            if (e.key === "ArrowRight") navLightbox(1);
            if (e.key === "ArrowLeft") navLightbox(-1);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [lightbox]);

    const openLightbox = (items, index = 0) => setLightbox({ items, index, zoom: 1 });
    const navLightbox = (dir) =>
        setLightbox((lb) =>
            lb ? { ...lb, index: (lb.index + dir + lb.items.length) % lb.items.length, zoom: 1 } : lb
        );
    const zoomLightbox = (dir) =>
        setLightbox((lb) =>
            lb ? { ...lb, zoom: Math.min(3, Math.max(1, +(lb.zoom + dir * 0.5).toFixed(1))) } : lb
        );

    return (
        <main data-testid="sgi-page" className="text-white" style={{ background: NAVY.base }}>
            {/* ============ HERO ============ */}
            <section data-testid="sgi-hero" className="relative min-h-[88vh] flex flex-col justify-end overflow-hidden">
                <div className="absolute inset-0 kenburns">
                    <img src={`${A}/hero-cover.png`} alt="Sadja Group Indonesia — shield and padlock over city skyline" className="w-full h-full object-cover" />
                </div>
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, #0a1628 4%, rgba(10,22,40,0.55) 45%, rgba(10,22,40,0.35) 100%)" }} />
                <div className="absolute inset-0 hero-grid" />

                <div className="relative z-10 max-w-[1440px] mx-auto w-full px-6 lg:px-12 pb-20 pt-44">
                    <Reveal>
                        <Link
                            to="/"
                            data-testid="sgi-back-to-sadja-core"
                            className="inline-flex items-center gap-2 font-display text-[11px] font-semibold tracking-[0.2em] uppercase text-white/60 hover:text-[#38bdf8] transition-colors duration-300 mb-10"
                        >
                            <ArrowLeft className="w-4 h-4" /> Kembali ke Sadja Core
                        </Link>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <img src={GLOBE_LOGO} alt="Sadja Group Indonesia globe logo" className="h-20 w-auto mb-8 drop-shadow-[0_0_24px_rgba(56,189,248,0.35)]" />
                    </Reveal>
                    <h1 className="font-display font-extrabold uppercase leading-[0.95] tracking-tight text-[13vw] sm:text-7xl lg:text-8xl text-white">
                        <MaskedLine delay={0.25}>Sadja Group</MaskedLine>
                        <MaskedLine delay={0.45} className="text-[#38bdf8]">
                            Indonesia
                        </MaskedLine>
                    </h1>
                    <Reveal delay={0.7}>
                        <p className="text-white/70 max-w-xl mt-6 text-base lg:text-lg leading-relaxed">
                            Teknologi Informasi &amp; Infrastruktur — dari Indonesia, untuk Indonesia.
                        </p>
                    </Reveal>
                </div>
            </section>

            {/* ============ STICKY IN-PAGE MENU ============ */}
            <nav
                data-testid="sgi-subnav"
                aria-label="Navigasi halaman"
                className="sticky top-[72px] z-40 border-b backdrop-blur-xl no-scrollbar overflow-x-auto"
                style={{ background: "rgba(10,22,40,0.88)", borderColor: NAVY.line }}
            >
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex items-center gap-2 h-[56px] w-max min-w-full">
                    {MENU.map((m) => (
                        <button
                            key={m.id}
                            data-testid={`sgi-subnav-${m.id}`}
                            onClick={() => scrollToId(m.id)}
                            className="font-display text-[11px] font-semibold tracking-[0.16em] uppercase text-white/60 hover:text-[#38bdf8] px-4 py-2 whitespace-nowrap transition-colors duration-300"
                        >
                            {m.label}
                        </button>
                    ))}
                </div>
            </nav>

            {/* ============ PROFIL ============ */}
            <section id="sgi-profil" data-testid="sgi-profil" className="py-24 lg:py-32">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Profil" />
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                        <Reveal className="lg:col-span-4">
                            <img
                                src={`${A}/profil-shield.png`}
                                alt="Glowing shield with padlock — keamanan siber"
                                className="w-full max-w-sm mx-auto mix-blend-screen"
                                loading="lazy"
                            />
                        </Reveal>
                        <Reveal delay={0.12} className="lg:col-span-8">
                            <div className="p-8 lg:p-12 border" style={{ background: NAVY.panel, borderColor: NAVY.line }}>
                                <div className="space-y-6 text-white/85 leading-relaxed text-sm lg:text-base">
                                    <p>
                                        PT Sadja Group Indonesia memiliki kompetensi di bidang teknologi informasi (IT) &amp; Infrastruktur asal Indonesia yang berfokus pada pengembangan perangkat lunak, cyber security, hardware, sistem pembayaran dan solusi transportasi publik.
                                    </p>
                                    <p>
                                        Sadja Group Indonesia juga telah dipercaya dalam beberapa Pembangunan Infrastruktur Sipil &amp; Design Arsitektur serta Mekanikal Elektrikal ringan. Kami percaya bahwa setiap tanggung jawab yang diamanahkan akan kami selesaikan dengan baik dan tepat waktu demi kepuasan klien.
                                    </p>
                                    <p>
                                        Kami berkomitmen untuk terus mengembangkan inovasi, meningkatkan kualitas, serta berkolaborasi dengan menerapkan sistem kerja yang efisien dalam setiap layanan yang kami berikan.
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* ============ SPESIALISASI KAMI ============ */}
            <section id="sgi-spesialisasi" data-testid="sgi-spesialisasi" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Spesialisasi Kami" />
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {[
                            {
                                num: "01",
                                title: "Pekerjaan Sipil Konstruksi & Desain",
                                desc: "Pembangunan pondasi, menara, fabrikasi, pemasangan struktur, pembangunan gedung serta seluruh pekerjaan sipil dan desain arsitektural.",
                                img: `${A}/spec-tower.png`,
                                alt: "Curved glass tower",
                            },
                            {
                                num: "02",
                                title: "Keamanan Siber (Cybersecurity)",
                                desc: "Perlindungan sistem dan data perusahaan melalui audit keamanan, pemantauan ancaman, manajemen akses, serta penerapan standar keamanan siber terkini.",
                                img: `${A}/spec-cyber.png`,
                                alt: "Shield with padlock and circuit lines",
                            },
                            {
                                num: "03",
                                title: "Pengembangan Aplikasi & Manajemen Server",
                                desc: "Pembangunan aplikasi sesuai kebutuhan bisnis, pengelolaan server, pemeliharaan infrastruktur IT, serta dukungan teknis berkelanjutan.",
                                img: `${A}/spec-cloud.png`,
                                alt: "Cloud above server racks",
                            },
                        ].map((s, i) => (
                            <Reveal key={s.num} delay={0.1 * i} className="h-full">
                                <article
                                    data-testid={`sgi-spec-${s.num}`}
                                    className="group h-full border flex flex-col overflow-hidden transition-colors duration-500 hover:border-[#38bdf8]/60"
                                    style={{ background: NAVY.base, borderColor: NAVY.line }}
                                >
                                    <div className="relative h-52 overflow-hidden bg-black/40">
                                        <img
                                            src={s.img}
                                            alt={s.alt}
                                            className="w-full h-full object-cover opacity-90 mix-blend-screen transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="p-7 flex flex-col flex-1">
                                        <span className="font-display text-3xl font-extrabold" style={{ color: NAVY.blue }}>{s.num}</span>
                                        <h3 className="font-display text-lg font-bold text-white mt-3 leading-snug">{s.title}</h3>
                                        <p className="text-sm text-white/65 leading-relaxed mt-3">{s.desc}</p>
                                    </div>
                                </article>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* ============ REKAM JEJAK ============ */}
            <section id="sgi-rekam-jejak" data-testid="sgi-rekam-jejak" className="py-24 lg:py-32">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Rekam Jejak" />
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                        <Reveal>
                            <div data-testid="sgi-track-pemerintah">
                                <div className="flex items-baseline gap-4 mb-6">
                                    <span className="font-display text-2xl font-extrabold" style={{ color: NAVY.blue }}>01</span>
                                    <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white">Pemerintah</h3>
                                </div>
                                <ul className="space-y-4 border-l pl-6" style={{ borderColor: NAVY.line }}>
                                    {[
                                        "Pengembangan Integrated App untuk Trans Semarang (Pemda Semarang & NG Indonesia)",
                                        "2024-2025 : Pembangunan Break Water Pantai Asem Doyong KSO PT. Wahyu Jati Abadi (Pemalang)",
                                        "2024-2025 : Pembangunan gedung sekolah SMA & SMK (Pemprov Jawa Tengah)",
                                        "2024-2025 : Revitalisasi RUSUN & Fasum Perumahan (Dinas Perumahan & Pemukiman Kota Semarang)",
                                        "2024-2025 : China Road and Bridge Construction (CRBC) - PP Bamboo and Boulder Rock Supply",
                                    ].map((item) => (
                                        <li key={item} className="text-sm text-white/75 leading-relaxed flex items-start gap-3">
                                            <Check className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.blue }} strokeWidth={2.5} />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                        <Reveal delay={0.12}>
                            <div data-testid="sgi-track-swasta">
                                <div className="flex items-baseline gap-4 mb-6">
                                    <span className="font-display text-2xl font-extrabold" style={{ color: NAVY.blue }}>02</span>
                                    <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white">Swasta</h3>
                                </div>
                                <ul className="space-y-4 border-l pl-6" style={{ borderColor: NAVY.line }}>
                                    {[
                                        "2024-2026: Kalla project house (Makassar) kso Jovanindo Perdana",
                                        "2024-2025: 4 Branch Best PR (Semarang)",
                                    ].map((item) => (
                                        <li key={item} className="text-sm text-white/75 leading-relaxed flex items-start gap-3">
                                            <Check className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.blue }} strokeWidth={2.5} />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* ============ PRODUK & PROYEK ============ */}
            <section id="sgi-produk" data-testid="sgi-produk" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Produk & Proyek" accent="green" />

                    {/* a) Logistic Tracking */}
                    <div data-testid="sgi-produk-logistic" className="mb-24">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            <Reveal>
                                <div>
                                    <h3 className="font-display text-2xl sm:text-3xl font-extrabold text-white">
                                        Logistic <span style={{ color: NAVY.green }}>Tracking</span>
                                    </h3>
                                    <p className="text-white/70 text-sm lg:text-base leading-relaxed mt-4 max-w-lg">
                                        Sistem pelacakan paket yang dirancang untuk perusahaan ekspedisi, cocok untuk pengiriman domestik maupun internasional.
                                    </p>
                                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-8">
                                        {[
                                            { icon: MapPin, label: "Live tracking" },
                                            { icon: Wallet, label: "Biaya Ekspedisi" },
                                            { icon: Calculator, label: "Kalkulator" },
                                            { icon: PackageCheck, label: "Delivery order" },
                                            { icon: Users, label: "Customer management" },
                                            { icon: Coins, label: "Currency" },
                                        ].map((f) => (
                                            <div
                                                key={f.label}
                                                className="flex items-center gap-3 border px-4 py-3"
                                                style={{ borderColor: "rgba(74,222,128,0.25)", background: "rgba(74,222,128,0.05)" }}
                                            >
                                                <f.icon className="w-4 h-4 shrink-0" style={{ color: NAVY.green }} strokeWidth={1.75} />
                                                <span className="text-xs text-white/80">{f.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <p className="font-display text-[11px] font-semibold tracking-[0.24em] uppercase mt-10 mb-4" style={{ color: NAVY.green }}>
                                        Telah digunakan oleh
                                    </p>
                                    <div className="flex flex-wrap gap-4">
                                        {[1, 2, 3].map((n) => (
                                            <div
                                                key={n}
                                                data-testid={`sgi-logistic-client-placeholder-${n}`}
                                                className="w-32 h-16 border border-dashed flex items-center justify-center"
                                                style={{ borderColor: "rgba(74,222,128,0.4)" }}
                                            >
                                                <span className="text-[10px] font-display tracking-[0.2em] uppercase text-white/35">Logo Klien</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Reveal>
                            <Reveal delay={0.15}>
                                <img
                                    src={`${A}/logistic-map.png`}
                                    alt="Green wireframe world map with logistics routes"
                                    className="w-full mix-blend-screen"
                                    loading="lazy"
                                />
                            </Reveal>
                        </div>
                    </div>

                    {/* b) FinTech */}
                    <div data-testid="sgi-produk-fintech" className="mb-24">
                        <Reveal>
                            <h3 className="font-display text-2xl sm:text-3xl font-extrabold text-white">
                                Fin<span style={{ color: NAVY.green }}>Tech</span>
                            </h3>
                            <p className="text-white/70 text-sm lg:text-base leading-relaxed mt-4 max-w-2xl">
                                Sistem aplikasi berbasis web yang dirancang untuk mengintegrasikan proses Know Your Customer (KYC) secara seamless, membuat akun global, serta memfasilitasi konversi dan transfer lintas negara.
                            </p>
                        </Reveal>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
                            {[
                                {
                                    title: "Customer Platform",
                                    items: ["Know your customer", "Global account management", "Beneficiary management", "Convert and Transfer", "Transaction", "Virtual Visa Card"],
                                },
                                {
                                    title: "Admin",
                                    items: ["User and Account Management", "FX Revenue Setting", "Revenue Summary"],
                                },
                            ].map((card, i) => (
                                <Reveal key={card.title} delay={0.1 * i}>
                                    <div className="h-full border p-8" style={{ background: NAVY.base, borderColor: "rgba(74,222,128,0.25)" }}>
                                        <h4 className="font-display text-lg font-bold text-white mb-6">{card.title}</h4>
                                        <ul className="space-y-3">
                                            {card.items.map((item) => (
                                                <li key={item} className="flex items-start gap-3 text-sm text-white/75">
                                                    <Check className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.green }} strokeWidth={2.5} />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>

                    {/* c) Website Universitas */}
                    <div data-testid="sgi-produk-universitas" className="mb-24">
                        <Reveal>
                            <h3 className="font-display text-2xl sm:text-3xl font-extrabold text-white">
                                Website <span style={{ color: NAVY.green }}>Universitas</span>
                            </h3>
                        </Reveal>
                        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4 mt-10">
                            {[
                                {
                                    step: "1",
                                    title: "Diskusi & Analisis Kebutuhan",
                                    desc: "Identifikasi tujuan website, target pengguna, dan fitur yang dibutuhkan.",
                                    output: "Dokumen kebutuhan & konsep awal.",
                                },
                                {
                                    step: "2",
                                    title: "Desain & Pembuatan Template",
                                    desc: "Membuat desain tampilan dan struktur website sesuai identitas lembaga.",
                                    output: "Template siap implementasi.",
                                },
                                {
                                    step: "3",
                                    title: "Pembuatan Server Sandbox (Testing)",
                                    desc: "Menyiapkan server uji coba untuk memastikan tampilan dan fitur berjalan baik.",
                                    output: "Versi percobaan website.",
                                },
                                {
                                    step: "4",
                                    title: "Implementasi ke Website Utama",
                                    desc: "Menangani kendala teknis atau gangguan pada website utama saat proses migrasi dan sandbox ke live dilakukan.",
                                    output: "Website aktif & siap digunakan.",
                                },
                                {
                                    step: "5",
                                    title: "Support, Pembaruan Komponen, & Pelatihan Pengelolaan Website",
                                    desc: "Menangani kendala teknis, menerima permintaan perubahan, dan update berkala. Memberikan training kepada admin lembaga agar bisa mengelola konten mandiri.",
                                    output: "Tim internal lembaga kini mampu mengoperasikan website sendiri. Website tetap stabil dan selalu dalam kondisi yang up to date.",
                                },
                            ].map((s, i) => (
                                <Reveal key={s.step} delay={0.07 * i} className="h-full">
                                    <div className="relative h-full border p-6 flex flex-col" style={{ background: NAVY.base, borderColor: "rgba(74,222,128,0.25)" }}>
                                        <div className="flex items-center justify-between mb-4">
                                            <span className="font-display text-2xl font-extrabold" style={{ color: NAVY.green }}>{s.step}</span>
                                            <ArrowDown className="w-4 h-4 xl:hidden" style={{ color: "rgba(74,222,128,0.5)" }} />
                                            <ArrowDown className="w-4 h-4 hidden xl:block -rotate-90" style={{ color: "rgba(74,222,128,0.5)" }} />
                                        </div>
                                        <h4 className="font-display text-sm font-bold text-white leading-snug">{s.title}</h4>
                                        <p className="text-xs text-white/60 leading-relaxed mt-3 flex-1">{s.desc}</p>
                                        <p className="text-[11px] mt-4 pt-4 border-t leading-relaxed" style={{ borderColor: "rgba(74,222,128,0.2)", color: NAVY.green }}>
                                            <span className="font-semibold uppercase tracking-wider">Output:</span> {s.output}
                                        </p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>

                        <div className="mt-14 border p-8 lg:p-10" style={{ borderColor: "rgba(74,222,128,0.25)", background: "rgba(74,222,128,0.04)" }}>
                            <p className="font-display text-[11px] font-semibold tracking-[0.28em] uppercase mb-8" style={{ color: NAVY.green }}>
                                Hasil Proyek
                            </p>
                            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
                                {[
                                    { value: "160", suffix: "+", label: "Halaman Website" },
                                    { value: "1", suffix: "", label: "Website Utama" },
                                    { value: "10", suffix: "+", label: "Fakultas" },
                                    { value: "140", suffix: "+", label: "Program Studi" },
                                    { value: "25", suffix: "+", label: "Lembaga" },
                                ].map((s) => (
                                    <div key={s.label} data-testid={`sgi-univ-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
                                        <Counter value={s.value} suffix={s.suffix} className="font-display text-4xl lg:text-5xl font-extrabold text-white" />
                                        <p className="text-xs text-white/55 mt-2 uppercase tracking-[0.14em] font-display">{s.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* d) Website Standar IPO */}
                    <div data-testid="sgi-produk-ipo">
                        <Reveal>
                            <h3 className="font-display text-2xl sm:text-3xl font-extrabold text-white">
                                Website Standar <span style={{ color: NAVY.green }}>IPO</span>
                            </h3>
                        </Reveal>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
                            {[
                                { num: "01", title: "Riset & Konsep Awal", desc: "Analisis kebutuhan brand & target internasional ESTA." },
                                { num: "02", title: "Desain Struktur & Identitas", desc: "Wireframe + mockup UI/UX sesuai brand premium" },
                                { num: "03", title: "Pengembangan Website", desc: "Website responsif & modern memenuhi standard IPO" },
                                { num: "04", title: "Konten & Optimasi", desc: "Integrasi sertifikat, produk, SEO dasar." },
                            ].map((s, i) => (
                                <Reveal key={s.num} delay={0.06 * i}>
                                    <div className="h-full border p-6" style={{ background: NAVY.base, borderColor: "rgba(74,222,128,0.25)" }}>
                                        <span className="font-display text-2xl font-extrabold" style={{ color: NAVY.green }}>{s.num}</span>
                                        <h4 className="font-display text-sm font-bold text-white mt-3 leading-snug">{s.title}</h4>
                                        <p className="text-xs text-white/60 leading-relaxed mt-2">{s.desc}</p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                            <Reveal>
                                <div className="h-full border p-8" style={{ background: NAVY.base, borderColor: "rgba(74,222,128,0.25)" }}>
                                    <p className="font-display text-[11px] font-semibold tracking-[0.24em] uppercase mb-5" style={{ color: NAVY.green }}>Hasil Proyek</p>
                                    <ul className="space-y-3">
                                        {["Website memenuhi standar IPO", "Kredibilitas meningkat, siap ekspansi pasar global"].map((item) => (
                                            <li key={item} className="flex items-start gap-3 text-sm text-white/80">
                                                <Check className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.green }} strokeWidth={2.5} />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Reveal>
                            <Reveal delay={0.1}>
                                <div className="h-full border p-8" style={{ background: NAVY.base, borderColor: "rgba(74,222,128,0.25)" }}>
                                    <p className="font-display text-[11px] font-semibold tracking-[0.24em] uppercase mb-5" style={{ color: NAVY.green }}>Deliverables</p>
                                    <ul className="space-y-3">
                                        {["Desain logo PT Esta Indonesia Tbk", "Website PT Esta Indonesia Tbk", "Pencatatan NEST di Bursa Saham"].map((item) => (
                                            <li key={item} className="flex items-start gap-3 text-sm text-white/80">
                                                <FileText className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.green }} strokeWidth={1.75} />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>

            {/* ============ JEJAK MITRA ============ */}
            <section id="sgi-mitra" data-testid="sgi-mitra" className="py-24 lg:py-32">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Jejak Mitra" center />
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: NAVY.line }}>
                        {[
                            "PT. BANDA KARYA ABADI",
                            "PT. KARYA MITRA NUGRAHA (KMN)",
                            "PT. WAHYU JATI ABADI",
                            "PT AYAMA",
                            "PT KEMBAR ABADI",
                            "CV JOVANINDO PERDANA",
                            "PT BEST PR",
                            "PT. ENVIROMATE TECHNOLOGY INTERNATIONAL (ETI)",
                            "PT INDISI",
                        ].map((m, i) => (
                            <Reveal key={m} delay={0.04 * i}>
                                <div
                                    data-testid={`sgi-partner-${i}`}
                                    className="h-full min-h-28 flex items-center justify-center text-center px-6 py-8 transition-colors duration-500"
                                    style={{ background: NAVY.panel }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#122544")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = NAVY.panel)}
                                >
                                    <span className="font-display text-sm font-bold tracking-[0.1em] text-white/85">{m}</span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* ============ KABINET KERJA ============ */}
            <section id="sgi-tim" data-testid="sgi-kabinet" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Kabinet Kerja" center />

                    <div className="flex flex-col items-center">
                        <Reveal>
                            <div data-testid="sgi-org-dirut" className="border px-8 py-5 text-center" style={{ background: NAVY.base, borderColor: NAVY.blue }}>
                                <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase" style={{ color: NAVY.blue }}>Direktur Utama</p>
                                <p className="font-display text-lg font-extrabold text-white mt-1.5">Bito Leilia Atmadja</p>
                            </div>
                        </Reveal>
                        <div className="w-px h-8" style={{ background: NAVY.line }} aria-hidden="true" />
                        <div className="hidden md:block h-px w-[420px]" style={{ background: NAVY.line }} aria-hidden="true" />
                        <div className="flex flex-col md:flex-row gap-6 md:gap-24 mt-0 md:mt-0">
                            <Reveal delay={0.1}>
                                <div className="flex flex-col items-center">
                                    <div className="hidden md:block w-px h-8" style={{ background: NAVY.line }} aria-hidden="true" />
                                    <div data-testid="sgi-org-dirops1" className="border px-8 py-5 text-center" style={{ background: NAVY.base, borderColor: NAVY.line }}>
                                        <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase" style={{ color: NAVY.blue }}>Direktur Operasional 1</p>
                                        <p className="font-display text-base font-bold text-white mt-1.5">Bima Eka Sakti</p>
                                    </div>
                                </div>
                            </Reveal>
                            <Reveal delay={0.2}>
                                <div className="flex flex-col items-center">
                                    <div className="hidden md:block w-px h-8" style={{ background: NAVY.line }} aria-hidden="true" />
                                    <div data-testid="sgi-org-dirops2" className="border px-8 py-5 text-center" style={{ background: NAVY.base, borderColor: NAVY.line }}>
                                        <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase" style={{ color: NAVY.blue }}>Direktur Operasional 2</p>
                                        <p className="font-display text-base font-bold text-white mt-1.5">Panchar Nirwana Siddik</p>
                                    </div>
                                </div>
                            </Reveal>
                        </div>

                        <div className="w-px h-8" style={{ background: NAVY.line }} aria-hidden="true" />
                        <Reveal delay={0.25}>
                            <div data-testid="sgi-org-pm" className="border px-8 py-4 text-center" style={{ background: NAVY.base, borderColor: NAVY.line }}>
                                <p className="font-display text-sm font-bold tracking-[0.12em] uppercase text-white">Project Manager</p>
                            </div>
                        </Reveal>
                        <div className="w-px h-8" style={{ background: NAVY.line }} aria-hidden="true" />

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 w-full max-w-5xl">
                            {[
                                { title: "General Affair", children: [] },
                                { title: "Site Engineer", children: ["Quantity Engineer", "Supervisor", "Structure Engineer"] },
                                { title: "Staff Akuntansi", children: [] },
                                { title: "Chief Inspector", children: ["Structure Engineer", "Structure Engineer"] },
                                { title: "Administrator Umum", children: [] },
                            ].map((u, i) => (
                                <Reveal key={u.title} delay={0.05 * i} className="h-full">
                                    <div
                                        data-testid={`sgi-org-unit-${i}`}
                                        className="h-full border p-5"
                                        style={{ background: NAVY.base, borderColor: NAVY.line }}
                                    >
                                        <p className="font-display text-xs font-bold tracking-[0.12em] uppercase text-white">{u.title}</p>
                                        {u.children.length > 0 && (
                                            <ul className="mt-3 space-y-2 border-l-2 pl-3" style={{ borderColor: NAVY.line }}>
                                                {u.children.map((child, ci) => (
                                                    <li key={ci} className="text-[11px] text-white/60 leading-snug">{child}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ============ LEGALITAS ============ */}
            <section id="sgi-legalitas" data-testid="sgi-legalitas" className="py-24 lg:py-32">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Legalitas Perusahaan" />
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <DocGroup
                            testidPrefix="sgi-legal-akta"
                            title="Akta Pendirian"
                            caption="Akta Pendirian Perseroan Terbatas PT Sadja Group Indonesia, Nomor 01, tanggal 12 April 2025. Notaris Nia Septiana Wulandari, S.H., M.Kn. — SK Menteri Kehakiman dan HAM RI No. AHU-00696.AH.0201.TAHUN 2017, 28 Juli 2017. Kantor: Jl. Mayjend Sutoyo Nomor 27, Gumawang, Wiradesa, Pekalongan."
                            items={[
                                { src: `${A}/legalitas-akta.png`, label: "Akta Pendirian Perseroan Terbatas PT Sadja Group Indonesia — Nomor 01, 12 April 2025 (Notaris Nia Septiana Wulandari, S.H., M.Kn.)" },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-nib"
                            title="NIB / Perizinan Berusaha Berbasis Risiko"
                            caption="Nomor Induk Berusaha 1604250060113, diterbitkan Jakarta 16 April 2025. Alamat: Jl. Ngesrep Barat 3, Komplek PP No. B6, Desa/Kelurahan Srondol Kulon, Kec. Banyumanik, Kota Semarang, Jawa Tengah, Kode Pos 50263. Status Penanaman Modal: PMDN. Skala Usaha: Mikro."
                            items={[
                                { src: `${A}/legalitas-nib.png`, label: "NIB / Perizinan Berusaha Berbasis Risiko — 1604250060113, diterbitkan 16 April 2025" },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-ahu"
                            title="Dokumen Kemenkum / AHU"
                            className="lg:col-span-2"
                            caption="(1) Penerimaan Pemberitahuan Perubahan Data Perseroan, Nomor AHU-AH.01.09-0115902, 20 Februari 2026. (2) Keputusan Menteri Hukum RI Nomor AHU-0005750.AH.01.02.TAHUN 2026 tentang Persetujuan Perubahan Anggaran Dasar PT Sadja Group Indonesia (disingkat PT SADJASA), 03 Februari 2026. (3) Lampiran keputusan: Modal Dasar Rp 100.000.000, Modal Ditempatkan Rp 25.000.000, susunan pemegang saham, dewan komisaris dan direksi."
                            items={[
                                { src: `${A}/legalitas-ahu-penerimaan.jpeg`, label: "Penerimaan Pemberitahuan Perubahan Data Perseroan — AHU-AH.01.09-0115902, 20 Februari 2026" },
                                { src: `${A}/legalitas-ahu-sk.jpeg`, label: "Keputusan Menteri Hukum RI — AHU-0005750.AH.01.02.TAHUN 2026, Persetujuan Perubahan Anggaran Dasar PT Sadja Group Indonesia" },
                                { src: `${A}/legalitas-ahu-lampiran.jpeg`, label: "Lampiran Keputusan Menteri — Modal Dasar Rp 100.000.000, susunan pemegang saham, dewan komisaris dan direksi" },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-npwp"
                            title="NPWP"
                            caption="NPWP 1000 0000 0144 8356 — SADJA GROUP INDONESIA. KPP Pratama Semarang Candisari. Tanggal terdaftar 16/04/2025."
                            items={[
                                { src: `${A}/legalitas-npwp.png`, label: "NPWP 1000 0000 0144 8356 — SADJA GROUP INDONESIA, KPP Pratama Semarang Candisari", landscape: true },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-standar"
                            title="Sertifikat Standar"
                            caption="Perizinan Berusaha Berbasis Risiko — Sertifikat Standar 16042500601130001, KBLI 41011 Konstruksi Konvensional Gedung Hunian, beserta lampirannya."
                            items={[
                                { src: `${A}/sertifikat-standar.jpeg`, label: "Sertifikat Standar 16042500601130001 — KBLI 41011 Konstruksi Konvensional Gedung Hunian" },
                                { src: `${A}/sertifikat-standar-lampiran.jpeg`, label: "Lampiran Sertifikat Standar 16042500601130001" },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-sbu-41012"
                            title="SBU Konstruksi — KBLI 41012"
                            caption="Sertifikat Badan Usaha (SBU) Konstruksi Nomor 202607080742053306454 — KBLI 41012 Konstruksi Gedung Perkantoran, subklasifikasi BG002, kualifikasi Kecil. Diterbitkan 8 Juli 2026, berlaku 2026-07-08 s.d. 2029-07-07. PJBU drg. Bito Leilia Atmadja; PJTBU Riscky Oktavianto; PJSKBU Bima Eka Sakti; Pelaksana sertifikasi PT. HIMJASA SERTIFIKASI MANDIRI."
                            items={[
                                { src: `${A}/sbu-41012.jpeg`, label: "SBU Konstruksi Nomor 202607080742053306454 — KBLI 41012 Konstruksi Gedung Perkantoran (BG002)" },
                                { src: `${A}/sbu-41012-lampiran.jpeg`, label: "Lampiran SBU Konstruksi Nomor 202607080742053306454" },
                            ]}
                            onOpen={openLightbox}
                        />
                        <DocGroup
                            testidPrefix="sgi-legal-sbu-41011"
                            title="SBU Konstruksi — KBLI 41011"
                            caption="Sertifikat Badan Usaha (SBU) Konstruksi Nomor 202607030828057903748 — KBLI 41011 Konstruksi Gedung Hunian, subklasifikasi BG001, kualifikasi Kecil. Diterbitkan 8 Juli 2026, berlaku 2026-07-08 s.d. 2029-07-07. PJBU drg. Bito Leilia Atmadja; PJTBU Riscky Oktavianto; PJSKBU Bima Eka Sakti; Pelaksana sertifikasi PT. HIMJASA SERTIFIKASI MANDIRI."
                            items={[
                                { src: `${A}/sbu-41011.jpeg`, label: "SBU Konstruksi Nomor 202607030828057903748 — KBLI 41011 Konstruksi Gedung Hunian (BG001)" },
                                { src: `${A}/sbu-41011-lampiran.jpeg`, label: "Lampiran SBU Konstruksi Nomor 202607030828057903748" },
                            ]}
                            onOpen={openLightbox}
                        />
                    </div>
                </div>
            </section>

            {/* ============ SERTIFIKAT KOMPETENSI KERJA ============ */}
            <section id="sgi-sertifikat" data-testid="sgi-skk" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="Sertifikat Kompetensi Kerja" />
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {[
                            {
                                id: "bima",
                                name: "Bima Eka Sakti",
                                role: "Pelaksana Lapangan Pekerjaan Gedung (Level 5)",
                                cert: "Sertifikat F7672130 — No. 85693 3112.03 5 00026783 2026",
                                items: [
                                    { src: `${A}/skk-bima-bnsp.jpeg`, label: "Sertifikat Kompetensi BNSP — Bima Eka Sakti, Pelaksana Lapangan Pekerjaan Gedung (Level 5)" },
                                    { src: `${A}/skk-bima-lpjk.jpeg`, label: "Daftar Unit Kompetensi LPJK — Bima Eka Sakti" },
                                ],
                            },
                            {
                                id: "riscky",
                                name: "Riscky Oktavianto",
                                role: "Pelaksana Lapangan Pekerjaan Gedung (Level 6)",
                                cert: "Sertifikat F7672131 — No. 85693 3112.03 6 00026784 2026",
                                items: [
                                    { src: `${A}/skk-riscky-bnsp.jpeg`, label: "Sertifikat Kompetensi BNSP — Riscky Oktavianto, Pelaksana Lapangan Pekerjaan Gedung (Level 6)" },
                                    { src: `${A}/skk-riscky-lpjk.jpeg`, label: "Daftar Unit Kompetensi LPJK — Riscky Oktavianto" },
                                ],
                            },
                        ].map((p, pi) => (
                            <Reveal key={p.id} delay={0.1 * pi} className="h-full">
                                <article
                                    data-testid={`sgi-skk-${p.id}`}
                                    className="h-full border p-7 lg:p-9 flex flex-col"
                                    style={{ background: NAVY.base, borderColor: NAVY.line }}
                                >
                                    <h3 className="font-display text-xl font-extrabold text-white">{p.name}</h3>
                                    <p className="font-display text-[11px] font-semibold tracking-[0.18em] uppercase mt-2" style={{ color: NAVY.blue }}>
                                        {p.role}
                                    </p>
                                    <ul className="mt-6 space-y-2.5 text-sm text-white/70 leading-relaxed flex-1">
                                        {[
                                            p.cert,
                                            "Berlaku 5 (lima) tahun, ditetapkan di Jakarta 26 Juni 2026",
                                            "Klasifikasi Sipil — Subklasifikasi Gedung — Kualifikasi Teknisi/Analis",
                                            "Diterbitkan LSP Tenaga Konstruksi Nasional atas nama BNSP",
                                        ].map((d) => (
                                            <li key={d} className="flex items-start gap-3">
                                                <Check className="w-4 h-4 shrink-0 mt-0.5" style={{ color: NAVY.blue }} strokeWidth={2.5} />
                                                {d}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="grid grid-cols-2 gap-4 mt-8">
                                        {p.items.map((doc, i) => (
                                            <button
                                                key={doc.label}
                                                data-testid={`sgi-skk-${p.id}-doc-${i}`}
                                                onClick={() => openLightbox(p.items, i)}
                                                className="group relative border overflow-hidden transition-colors duration-500 hover:border-[#38bdf8]/60"
                                                style={{ borderColor: NAVY.line }}
                                            >
                                                <img
                                                    src={doc.src}
                                                    alt={doc.label}
                                                    className="w-full h-44 object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                                                    loading="lazy"
                                                />
                                                <span className="absolute bottom-2 right-2 text-[9px] font-display font-semibold tracking-[0.18em] uppercase text-white/70 bg-black/50 backdrop-blur-sm px-2 py-1">
                                                    Perbesar
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                </article>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* ============ KBLI ============ */}
            <section id="sgi-kbli" data-testid="sgi-kbli" className="py-24 lg:py-32">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="KBLI" />
                    <Reveal>
                        <p className="text-white/65 text-sm lg:text-base leading-relaxed max-w-2xl -mt-6 mb-10">
                            Daftar kegiatan usaha yang telah terdaftar pada NIB.
                        </p>
                    </Reveal>
                    <DocGallery
                        items={[1, 2, 3, 4, 5, 6].map((n) => ({
                            src: `${A}/kbli-lampiran-${n}.png`,
                            label: `Lampiran Perizinan Berusaha Berbasis Risiko — Jenis Bidang Usaha, NIB 1604250060113 (Halaman ${n})`,
                        }))}
                        onOpen={openLightbox}
                        testidPrefix="sgi-kbli"
                    />
                </div>
            </section>

            {/* ============ KBLI (ON PROCESS) ============ */}
            <section data-testid="sgi-kbli-process" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <SectHead overline="PT Sadja Group Indonesia" title="KBLI (On Process)" />

                    {/* a) Daftar KBLI dalam proses */}
                    <Reveal>
                        <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white mb-8">
                            Daftar <span style={{ color: NAVY.blue }}>KBLI</span> Dalam Proses
                        </h3>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <div className="relative max-w-md mb-8">
                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40 pointer-events-none" />
                            <input
                                data-testid="sgi-kbli-search"
                                type="text"
                                value={kbliQuery}
                                onChange={(e) => setKbliQuery(e.target.value)}
                                placeholder="Cari kode atau judul KBLI…"
                                aria-label="Cari kode atau judul KBLI"
                                className="w-full bg-transparent border pl-11 pr-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:border-[#38bdf8] transition-colors duration-300"
                                style={{ borderColor: NAVY.line }}
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <KbliTable
                            rows={KBLI_PROSES.filter(([no, kode, judul]) =>
                                `${kode} ${judul}`.toLowerCase().includes(kbliQuery.trim().toLowerCase())
                            )}
                        />
                        <p data-testid="sgi-kbli-table-count" className="mt-3 text-xs text-white/40 font-display tracking-[0.1em] uppercase">
                            Menampilkan {KBLI_PROSES.filter(([no, kode, judul]) => `${kode} ${judul}`.toLowerCase().includes(kbliQuery.trim().toLowerCase())).length} dari {KBLI_PROSES.length} KBLI dalam proses
                        </p>
                    </Reveal>
                    <div className="mt-10">
                        <p className="font-display text-[11px] font-semibold tracking-[0.24em] uppercase mb-5" style={{ color: NAVY.blue }}>
                            Dokumen Sumber
                        </p>
                        <DocGallery
                            items={[
                                { src: `${A}/kbli-proses-tabel-1.jpeg`, label: "Daftar KBLI dalam proses — halaman 1 (No. 1–33)" },
                                { src: `${A}/kbli-proses-tabel-2.jpeg`, label: "Daftar KBLI dalam proses — halaman 2 (No. 34–54)" },
                            ]}
                            onOpen={openLightbox}
                            testidPrefix="sgi-kbli-proses-doc"
                        />
                    </div>

                    {/* b) Usulan KBLI */}
                    <Reveal>
                        <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white mt-24 mb-8">
                            Usulan <span style={{ color: NAVY.blue }}>KBLI</span>
                        </h3>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <div data-testid="sgi-kbli-usulan-table" className="border overflow-x-auto" style={{ borderColor: NAVY.line }}>
                            <table className="w-full text-sm min-w-[820px]">
                                <thead>
                                    <tr style={{ background: "rgba(56,189,248,0.08)" }}>
                                        {["No", "KBLI", "Nama KBLI", "Peran dalam Bisnis", "Justifikasi Penambahan / Penegasan"].map((h) => (
                                            <th key={h} className="px-5 py-4 text-left font-display text-[11px] font-semibold tracking-[0.16em] uppercase" style={{ color: NAVY.blue }}>
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {USULAN_KBLI.map((r) => (
                                        <tr key={r.no} className="border-t align-top transition-colors duration-300 hover:bg-white/[0.03]" style={{ borderColor: NAVY.line }}>
                                            <td className="px-5 py-4 text-white/50 w-12">{r.no}</td>
                                            <td className="px-5 py-4 font-display font-bold whitespace-nowrap" style={{ color: NAVY.blue }}>{r.kbli}</td>
                                            <td className="px-5 py-4 text-white/85">{r.nama}</td>
                                            <td className="px-5 py-4 text-white/70 whitespace-nowrap">{r.peran}</td>
                                            <td className="px-5 py-4 text-white/60 leading-relaxed">{r.justifikasi}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Reveal>
                    <div className="mt-10">
                        <p className="font-display text-[11px] font-semibold tracking-[0.24em] uppercase mb-5" style={{ color: NAVY.blue }}>
                            Dokumen Sumber
                        </p>
                        <DocGallery
                            items={[
                                { src: `${A}/kbli-usulan-1.jpeg`, label: "Usulan KBLI — Memorandum Internal, Divisi Product Portfolio (No. 1–5)" },
                                { src: `${A}/kbli-usulan-2.jpeg`, label: "Usulan KBLI — lanjutan tabel (No. 6–8)" },
                            ]}
                            onOpen={openLightbox}
                            testidPrefix="sgi-kbli-usulan-doc"
                        />
                    </div>
                </div>
            </section>

            {/* ============ KONTAK KAMI ============ */}
            <section id="sgi-kontak" data-testid="sgi-kontak" className="py-24 lg:py-32" style={{ background: NAVY.panel }}>
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                        <Reveal className="lg:col-span-4">
                            <div className="text-center lg:text-left">
                                <img src={GLOBE_LOGO} alt="Sadja Group Indonesia globe logo" className="h-44 w-auto mx-auto lg:mx-0 drop-shadow-[0_0_30px_rgba(56,189,248,0.3)]" />
                                <p className="font-display font-extrabold tracking-[0.18em] text-white mt-6">PT SADJA GROUP INDONESIA</p>
                            </div>
                        </Reveal>
                        <div className="lg:col-span-8">
                            <SectHead overline="PT Sadja Group Indonesia" title="Kontak Kami" />
                            <div className="space-y-6">
                                <Reveal delay={0.05}>
                                    <div className="flex items-start gap-5">
                                        <div className="w-11 h-11 border flex items-center justify-center shrink-0" style={{ borderColor: NAVY.line }}>
                                            <Phone className="w-5 h-5" style={{ color: NAVY.blue }} strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase mb-2" style={{ color: NAVY.blue }}>Telepon</p>
                                            <div className="flex flex-col gap-1.5">
                                                <a data-testid="sgi-phone-1" href="tel:+62817581774" className="text-sm text-white/85 hover:text-[#38bdf8] transition-colors duration-300">+62 817-581-174</a>
                                                <a data-testid="sgi-phone-2" href="tel:+62818181174" className="text-sm text-white/85 hover:text-[#38bdf8] transition-colors duration-300">+62 818-181-174</a>
                                            </div>
                                        </div>
                                    </div>
                                </Reveal>
                                <Reveal delay={0.1}>
                                    <div className="flex items-start gap-5">
                                        <div className="w-11 h-11 border flex items-center justify-center shrink-0" style={{ borderColor: NAVY.line }}>
                                            <Mail className="w-5 h-5" style={{ color: NAVY.blue }} strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase mb-2" style={{ color: NAVY.blue }}>Email</p>
                                            <a data-testid="sgi-email" href="mailto:Sadjagroupindonesia@gmail.com" className="text-sm text-white/85 hover:text-[#38bdf8] transition-colors duration-300 break-all">Sadjagroupindonesia@gmail.com</a>
                                        </div>
                                    </div>
                                </Reveal>
                                <Reveal delay={0.15}>
                                    <div className="flex items-start gap-5">
                                        <div className="w-11 h-11 border flex items-center justify-center shrink-0" style={{ borderColor: NAVY.line }}>
                                            <Globe className="w-5 h-5" style={{ color: NAVY.blue }} strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase mb-2" style={{ color: NAVY.blue }}>Website</p>
                                            <a data-testid="sgi-website" href="https://www.sadjacorecorp.com" target="_blank" rel="noopener noreferrer" className="text-sm text-white/85 hover:text-[#38bdf8] transition-colors duration-300">Www.sadjacorecorp.com</a>
                                        </div>
                                    </div>
                                </Reveal>
                                <Reveal delay={0.2}>
                                    <div className="flex items-start gap-5">
                                        <div className="w-11 h-11 border flex items-center justify-center shrink-0" style={{ borderColor: NAVY.line }}>
                                            <MapPin className="w-5 h-5" style={{ color: NAVY.blue }} strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase mb-2" style={{ color: NAVY.blue }}>Alamat</p>
                                            <address data-testid="sgi-address" className="not-italic text-sm text-white/70 leading-relaxed max-w-md">
                                                Fourzone Mezzanine Floor, Grand Sahid Jaya, Jl. Jenderal Sudirman No. Kav. 86, Karet Tengsin, Tanah Abang, Kota Jakarta Pusat, DKI Jakarta 10220.
                                            </address>
                                        </div>
                                    </div>
                                </Reveal>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ============ CLOSING CTA ============ */}
            <section data-testid="sgi-closing" className="relative py-32 lg:py-44 overflow-hidden">
                <div className="absolute inset-0">
                    <img src={`${A}/hero-cover.png`} alt="" className="w-full h-full object-cover opacity-40" loading="lazy" />
                </div>
                <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, #0a1628 0%, rgba(10,22,40,0.55) 50%, #0a1628 100%)" }} />
                <img
                    src={`${A}/closing-visual.png`}
                    alt=""
                    aria-hidden="true"
                    className="absolute right-0 top-1/2 -translate-y-1/2 w-[420px] max-w-[60vw] mix-blend-screen opacity-70 pointer-events-none"
                />
                <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 text-center">
                    <Reveal>
                        <h2 className="font-display font-extrabold uppercase leading-[0.95] tracking-tight text-[11vw] sm:text-6xl lg:text-7xl text-white">
                            Mari <span style={{ color: NAVY.blue }}>Berkolaborasi</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <button
                            data-testid="sgi-closing-cta"
                            onClick={() => scrollToId("sgi-kontak")}
                            className="mt-10 inline-flex items-center gap-3 font-display font-bold text-xs tracking-[0.18em] uppercase px-10 py-4 text-[#0a1628] transition-colors duration-300"
                            style={{ background: NAVY.blue }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#7dd3fc")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = NAVY.blue)}
                        >
                            Kontak Kami
                        </button>
                    </Reveal>
                </div>
            </section>

            {/* ============ LIGHTBOX ============ */}
            {lightbox && (
                <div
                    data-testid="sgi-lightbox"
                    role="dialog"
                    aria-modal="true"
                    aria-label={lightbox.items[lightbox.index].label}
                    className="fixed inset-0 z-[90] flex items-center justify-center p-4 sm:p-10"
                    style={{ background: "rgba(4,10,20,0.92)" }}
                    onClick={() => setLightbox(null)}
                >
                    <button
                        data-testid="sgi-lightbox-close"
                        onClick={() => setLightbox(null)}
                        aria-label="Tutup"
                        className="absolute top-5 right-5 z-10 w-11 h-11 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <div className="absolute top-5 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                        <button
                            data-testid="sgi-lightbox-zoom-out"
                            onClick={() => zoomLightbox(-1)}
                            disabled={lightbox.zoom <= 1}
                            aria-label="Perkecil"
                            className="w-10 h-10 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors disabled:opacity-30 disabled:pointer-events-none"
                        >
                            <ZoomOut className="w-4 h-4" />
                        </button>
                        <span data-testid="sgi-lightbox-zoom-level" className="w-12 text-center font-display text-[11px] font-semibold tracking-[0.14em] text-white/70">
                            {Math.round(lightbox.zoom * 100)}%
                        </span>
                        <button
                            data-testid="sgi-lightbox-zoom-in"
                            onClick={() => zoomLightbox(1)}
                            disabled={lightbox.zoom >= 3}
                            aria-label="Perbesar"
                            className="w-10 h-10 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors disabled:opacity-30 disabled:pointer-events-none"
                        >
                            <ZoomIn className="w-4 h-4" />
                        </button>
                        <a
                            data-testid="sgi-lightbox-download"
                            href={lightbox.items[lightbox.index].src}
                            download
                            aria-label="Unduh dokumen"
                            className="w-10 h-10 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors"
                        >
                            <Download className="w-4 h-4" />
                        </a>
                    </div>

                    {lightbox.items.length > 1 && (
                        <>
                            <button
                                data-testid="sgi-lightbox-prev"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navLightbox(-1);
                                }}
                                aria-label="Dokumen sebelumnya"
                                className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 z-10 w-11 h-11 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors"
                            >
                                <ChevronLeft className="w-5 h-5" />
                            </button>
                            <button
                                data-testid="sgi-lightbox-next"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navLightbox(1);
                                }}
                                aria-label="Dokumen berikutnya"
                                className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 z-10 w-11 h-11 border border-white/25 flex items-center justify-center text-white hover:border-[#38bdf8] hover:text-[#38bdf8] transition-colors"
                            >
                                <ChevronRight className="w-5 h-5" />
                            </button>
                        </>
                    )}

                    <figure className="max-w-4xl w-full mt-14" onClick={(e) => e.stopPropagation()}>
                        <div data-testid="sgi-lightbox-viewport" className="overflow-auto max-h-[72vh] border border-white/10">
                            <img
                                src={lightbox.items[lightbox.index].src}
                                alt={lightbox.items[lightbox.index].label}
                                className="block mx-auto object-contain transition-[width] duration-300"
                                style={{ width: `${lightbox.zoom * 100}%`, maxWidth: "none" }}
                            />
                        </div>
                        <figcaption className="text-center text-xs text-white/70 mt-4 leading-relaxed">
                            {lightbox.items.length > 1 && (
                                <span data-testid="sgi-lightbox-counter" className="text-white/40 mr-2 font-display tracking-[0.14em]">
                                    {lightbox.index + 1} / {lightbox.items.length}
                                </span>
                            )}
                            {lightbox.items[lightbox.index].label}
                        </figcaption>
                    </figure>
                </div>
            )}
        </main>
    );
}

const DocGallery = ({ items, onOpen, testidPrefix }) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((doc, i) => (
            <Reveal key={doc.label} delay={0.05 * i}>
                <button
                    data-testid={`${testidPrefix}-doc-${i}`}
                    onClick={() => onOpen(items, i)}
                    className="group w-full text-left border overflow-hidden transition-colors duration-500 hover:border-[#38bdf8]/60"
                    style={{ background: "#0f1f38", borderColor: "#1e3a5f" }}
                >
                    <div className="relative h-52 overflow-hidden">
                        <img
                            src={doc.src}
                            alt={doc.label}
                            className="w-full h-full object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                            loading="lazy"
                        />
                        <span className="absolute bottom-3 right-3 text-[9px] font-display font-semibold tracking-[0.18em] uppercase text-white/70 bg-black/50 backdrop-blur-sm px-2.5 py-1">
                            Klik untuk perbesar
                        </span>
                    </div>
                    <p className="text-xs text-white/75 leading-relaxed p-4">{doc.label}</p>
                </button>
            </Reveal>
        ))}
    </div>
);

const DocGroup = ({ title, caption, items, onOpen, testidPrefix, className = "" }) => (
    <Reveal className={className}>
        <article
            data-testid={testidPrefix}
            className="h-full border p-6 lg:p-8 flex flex-col"
            style={{ background: NAVY.panel, borderColor: NAVY.line }}
        >
            <h3 className="font-display text-base lg:text-lg font-bold text-white leading-snug">{title}</h3>
            <div className={`grid gap-4 mt-6 ${items.length === 1 ? "grid-cols-1" : items.length === 2 ? "grid-cols-2" : "grid-cols-2 sm:grid-cols-3"}`}>
                {items.map((doc, i) => (
                    <button
                        key={doc.label}
                        data-testid={`${testidPrefix}-doc-${i}`}
                        onClick={() => onOpen(items, i)}
                        className="group relative border overflow-hidden transition-colors duration-500 hover:border-[#38bdf8]/60"
                        style={{ borderColor: NAVY.line }}
                    >
                        <img
                            src={doc.src}
                            alt={doc.label}
                            className={`w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${doc.landscape ? "h-40 object-center" : "h-48 object-top"}`}
                            loading="lazy"
                        />
                        <span className="absolute bottom-2 right-2 text-[9px] font-display font-semibold tracking-[0.18em] uppercase text-white/70 bg-black/50 backdrop-blur-sm px-2 py-1">
                            Perbesar
                        </span>
                    </button>
                ))}
            </div>
            <p className="text-xs lg:text-sm text-white/60 leading-relaxed mt-5">{caption}</p>
        </article>
    </Reveal>
);

const KbliTable = ({ rows }) => (
    <div data-testid="sgi-kbli-table" className="border overflow-x-auto" style={{ borderColor: NAVY.line }}>
        <table className="w-full text-sm min-w-[560px]">
            <thead>
                <tr style={{ background: "rgba(56,189,248,0.08)" }}>
                    <th className="px-5 py-4 text-left font-display text-[11px] font-semibold tracking-[0.16em] uppercase w-16" style={{ color: NAVY.blue }}>
                        No
                    </th>
                    <th className="px-5 py-4 text-left font-display text-[11px] font-semibold tracking-[0.16em] uppercase w-28" style={{ color: NAVY.blue }}>
                        Kode KBLI
                    </th>
                    <th className="px-5 py-4 text-left font-display text-[11px] font-semibold tracking-[0.16em] uppercase" style={{ color: NAVY.blue }}>
                        Judul KBLI
                    </th>
                </tr>
            </thead>
            <tbody>
                {rows.map(([no, kode, judul]) => (
                    <tr key={no} className="border-t transition-colors duration-300 hover:bg-white/[0.03]" style={{ borderColor: NAVY.line }}>
                        <td className="px-5 py-3 text-white/50">{no}</td>
                        <td className="px-5 py-3 font-display font-bold" style={{ color: NAVY.blue }}>
                            {kode}
                        </td>
                        <td className="px-5 py-3 text-white/80 leading-relaxed">{judul}</td>
                    </tr>
                ))}
                {rows.length === 0 && (
                    <tr>
                        <td colSpan={3} className="px-5 py-10 text-center text-sm text-white/45">
                            Tidak ada KBLI yang cocok dengan pencarian.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
);
